import './BetbookSearchDialog.less';
import './BetbookSearchDetailedBetsDialog.less';

import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';
import { PENDING, EMPTY, DATA } from '@/common/dataState';
import PrematchDetailBets from '@/nikeone/components/PrematchDetailBets';
import MiniScoreboardPrematch from '@/nikeone/components/MiniScoreboardPrematch';
import BoxOptionsContext, { BETBOOK } from '@/nikeone/context/BoxOptionsContext';
import DeleteIcon from '@/icons/DeleteIcon';
import LoaderMini from '@/ui/views/LoaderMini';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import { detailData$, detailDataState$ } from '@/nikeone/subs-detail';
import { loadEventDetail } from '@/nikeone/handlers-detail';
import { fromJS } from 'immutable';
import { trackingPropsForSportEvent } from '@/common/tracking';
import { ErrorBoundary } from 'nike-ui/src/common/ErrorBoundary';
import { COMMUNITY_LOBBY } from '@/routing/routes';

function BetbookSearchDetailedBetsDialog({ sportEventId, forceBetSelection = false }) {
    useEffect(() => {
        dispatch(loadEventDetail(sportEventId));
    }, [sportEventId]);

    const { subscribe } = useReframe();
    const detailData = subscribe(detailData$);
    const dataState = subscribe(detailDataState$(sportEventId));

    function onClose() {
        if (forceBetSelection) {
            dispatch(['history_back', COMMUNITY_LOBBY]);
        }
        PopupNg.dispatcher.closeAll();
    }

    return (
        <Docked onClose={onClose}>
            <BoxOptionsContext.Provider value={BETBOOK}>
                <DialogTitle className="betbook-search-detailed-bets-title">
                    <h2>{i18n('betbook.post.chooseTip')}</h2>
                    <MiniScoreboardContent
                        detailData={detailData}
                        dataState={dataState}
                        forceBetSelection={forceBetSelection}
                    />
                </DialogTitle>
                <DialogBody className="betbook-search-detailed-bets-body">
                    <BetsDialogContent dataState={dataState} detailData={detailData} />
                </DialogBody>
            </BoxOptionsContext.Provider>
        </Docked>
    );
}

function BetsDialogContent({ dataState, detailData }) {
    if (dataState === PENDING) {
        return <LoaderMini className="infinite-loader betbook-more-posts-loader" key="loader" />;
    }

    if (dataState === EMPTY) {
        return <EmptyState text={i18n('betbook.search.odds.not.found')} />;
    }
    return (
        <ErrorBoundary description={'betbook-dialog-content'}>
            <PrematchDetailBets detailData={fromJS(detailData)} betbookActive />
        </ErrorBoundary>
    );
}

function MiniScoreboardContent({ dataState, detailData, forceBetSelection }) {
    if (dataState === PENDING) {
        return <LoaderMini className="infinite-loader betbook-more-posts-loader" key="loader" />;
    }

    if (dataState === EMPTY) {
        return null;
    }
    const fullSportEvent = detailData.sportEvent;
    const firstBetId = detailData.box.betIds[0];
    function onClose() {
        if (forceBetSelection) {
            dispatch(['history_back', COMMUNITY_LOBBY]);
        }
        PopupNg.dispatcher.close();
    }

    return (
        <div className="betbook-search-detailed-bets" {...trackingPropsForSportEvent(fromJS(fullSportEvent))}>
            <div data-atid="nikeone-match" className="nikeone-match nikeone-match-prematch">
                <MiniScoreboardPrematch
                    sportEvent={fromJS(fullSportEvent)}
                    betId={fromJS(firstBetId)}
                    boxStore="BETBOOK"
                    disableClick
                />
                {dataState === DATA ? (
                    <div className="betbook-search-detailed-bets-delete-icon" onClick={onClose}>
                        <DeleteIcon height={8} width={8} fill={'#fff'} stroke={'#fff'} strokeWidth={2} />
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default BetbookSearchDetailedBetsDialog;
